import React, { useState } from 'react';
import ScrollGames from '../ScrollGames/ScrollGames';

const GameRules = () => {
  // 1. State to manage the current language, default is 'english'
  const [language, setLanguage] = useState('english');

  // 2. An object to hold the URLs for different languages
  // IMPORTANT: Replace the 'hindi' URL with your actual link
  const ruleUrls = {
    english: 'https://rules.staticcontent.io/englishrules.html',
    hindi: 'https://rules.staticcontent.io/hindirules.html', // <-- Replace with your Hindi rules URL
  };

  return (
    <>
      {/* <ScrollGames /> */}
      <p className="open-para">
        <span>Rules</span>
      </p>
      <div className="min-h-screen bg-gray-100  flex">
        <div className="w-full max-w-4xl mx-auto flex flex-col bg-white rounded-lg shadow-lg overflow-hidden">

          {/* Header section for the language buttons */}
          <div className="p-3 bg-gray-50 border-b border-gray-200 flex justify-center items-center gap-2">
            <button
              onClick={() => setLanguage('english')}
              // 3. Conditional styling with Tailwind CSS
              className={`px-4 py-2 text-sm font-semibold rounded  transition-colors duration-200 ease-in-out ${language === 'english'
                ? 'bg-[linear-gradient(#03363e,#045662)] border border-[#045662] text-white shadow'
                : ' text-gray-800 hover:bg-gray-200 '
                }`}
            >
              English
            </button>
            <button
              onClick={() => setLanguage('hindi')}
              className={`px-4 py-2 text-sm font-semibold rounded transition-colors duration-200 ease-in-out ${language === 'hindi'
                ? 'bg-[linear-gradient(#03363e,#045662)] border border-[#045662] text-white shadow'
                : ' text-gray-800 hover:bg-gray-200 '
                }`}
            >
              हिन्दी (Hindi)
            </button>
          </div>

          {/* Iframe to display the content */}
          <div className="relative w-full flex-grow">
            {/* A simple loading indicator */}
            <div className="absolute inset-0 flex items-center justify-center bg-white">
              <p className="text-gray-500">Loading Rules...</p>
            </div>
            <iframe
              // 4. The 'key' prop is crucial. It forces the iframe to re-render when the language changes.
              key={language}
              // 5. The 'src' is now dynamic based on the state
              src={ruleUrls[language]}
              title="Game Rules"
              className="absolute top-0 left-0 w-full h-full border-0"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default GameRules;